import { Injectable } from '@angular/core';
import { DataCoreService } from '../../../../services/data-core.service';
import { CtlGasBirimDosyaBelgeService } from '../ctl-gas-birim-dosya-belge.service';

@Injectable({
  providedIn: 'root'
})
export class CtlGasBirimDosyaBelgeAramaService {

  constructor(private dataCoreService: DataCoreService, private service: CtlGasBirimDosyaBelgeService) {}

  getData(control: any) {
          const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity,['GenDosyaPlan']);
          dataSource.select(['Kod','DosyaPlanKod','GenDosyaPlan.Ad'])
          
          const filterArr = [];
          if(this.service.birim) filterArr.push(['BirimKod', '=', this.service.birim]);
          dataSource.filter(filterArr);
    //    dataSource.select(['GenDosyaPlan.Ad','GenDosyaPlan.DosyaPlanKod']);

          return dataSource;
  }}
